/** 생성기 파일 올리기 — 파일 탭에서 자료가 아직 없을 때 놓인다. 순수 UI 다. */
import { Button } from '@zep-us/zus/button';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { UploadIcon } from '@zep-us/zus-icons';
import { type AiGenerateDockCopy } from '../types/aiGenerateDock.types';
export const AiGenerateDockAttachFileButton = ({
  copy,
  onAttach
}: {
  copy: AiGenerateDockCopy;
  onAttach: () => void;
}) => <div className="flex w-full" data-sentry-component="AiGenerateDockAttachFileButton" data-sentry-source-file="AiGenerateDockAttachFileButton.tsx">
    <Button size="sm" variant="outlined" intent="neutral" data-testid="ai-generate-dock-attach-file" leftSlot={<UploadIcon size="xs" fill={ICON_COLOR.neutral} aria-hidden />} onClick={onAttach} data-sentry-element="Button" data-sentry-source-file="AiGenerateDockAttachFileButton.tsx">
      {copy.attachFile}
    </Button>
  </div>;